import "react-app-polyfill/ie11"; // For IE 11 support
import "react-app-polyfill/stable";
import "core-js";
import "./polyfill";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import './tailwind.css';
import { ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material";

import { icons } from "./assets/icons";

import { Provider } from "react-redux";
import store from "./store";
import TrackUser from "./TrackUser";
const theme = createTheme({
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            height: "28px", // Smaller height for the input field
            fontSize: "12px", // Smaller font size
          },
          "& .MuiOutlinedInput-input": {
            padding: "4px 8px", // Adjust padding for input
          },
          "& .MuiInputLabel-root": {
            fontSize: "13px", // Smaller font size for labels
            transform: "translate(12px, 6px) scale(1)", // Center the label at the top
          },
          "& .MuiInputLabel-shrink": {
            transform: "translate(12px, -6px) scale(0.85)", // Shift label to the right and top when shrunk
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "", // Default border color
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "", // Black on hover
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "", // Black when focused
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            height: "28px", // Adjust height of Select field
            fontSize: "12px", // Smaller font size
          },
          "& .MuiOutlinedInput-input": {
            padding: "4px 8px", // Adjust padding inside Select field
          },
          "& .MuiInputLabel-root": {
            fontSize: "13px",
            transform: "translate(12px, 6px) scale(1)",
          },
          "& .MuiInputLabel-shrink": {
            transform: "translate(12px, -6px) scale(0.85)",
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          fontSize: "12px",
          padding: "4px 8px",
        },
        outlined: {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "black",
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            color: "black", // Black color for the shrunk label
          },
          fontSize: "8px", // Smaller helper text font size
        },
      },
    },
  },
});

React.icons = icons;

ReactDOM.render(
  <Provider store={store}>
     {/* <ThemeProvider theme={theme}> */}
     <TrackUser>
      <App />
    </TrackUser>
     {/* </ThemeProvider> */}
   
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
